/**
 * LiveMapOnlyPage.jsx · v2.7.63+E48
 * ─────────────────────────────────────────────────────────────────────
 * Chrome-free wrapper for JUST the Live Dispatch Map — used when
 * dispatchers pop out the map from the Grid Console. No sidebar, no
 * admin nav, just the streaming map filling the window edge to edge.
 *
 * Auth is inherited from localStorage (same origin) so the popup
 * doesn't need its own login flow.
 */
import { useEffect } from "react";
import LiveDispatchMap from "@/components/LiveDispatchMap";
import OperatorBadge from "@/components/admin/OperatorBadge";

export default function LiveMapOnlyPage() {
  useEffect(() => {
    // Body flag lets any leftover CSS know it should hide chrome.
    document.body.dataset.mapOnly = "true";
    return () => { delete document.body.dataset.mapOnly; };
  }, []);

  const token = localStorage.getItem("rtg_admin_token") || "";

  return (
    <>
      <OperatorBadge/>
      <div
        className="fixed inset-0 bg-zinc-950"
        data-testid="live-map-only-wrapper"
      >
        <LiveDispatchMap
          token={token}
          active={true}
          height="100vh"
          fullscreenEnabled={true}
        />
      </div>
    </>
  );
}
